module.exports = __webpack_public_path__ + "media/application/images/unesco-blue-65fefc31577c58401b1a7ed88c5899602d4acc830285a74efb9abfd251420202.png";